import { render, staticRenderFns } from "./SectionOurValues.vue?vue&type=template&id=2356958f&scoped=true"
import script from "./SectionOurValues.vue?vue&type=script&lang=ts"
export * from "./SectionOurValues.vue?vue&type=script&lang=ts"
import style0 from "./SectionOurValues.vue?vue&type=style&index=0&id=2356958f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2356958f",
  null
  
)

export default component.exports